import { jsx as f } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.es.js";
import { SvgIcon } from "@mui/material";
const i = "rgba(23, 31, 54, 0.24)";
function C(l) {
  const r = l.disabled ? i : "currentColor";
  return /* @__PURE__ */ f(SvgIcon, { ...l, children: /* @__PURE__ */ f("svg", { width: "2rem", height: "2rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M9.94489 17.9743C9.70293 17.9743 9.46093 17.8824 9.27694 17.6971C8.90769 17.3279 8.90769 16.7292 9.27694 16.36L13.6499 11.987L9.27694 7.61408C8.90769 7.24483 8.90769 6.64618 9.27694 6.27693C9.64618 5.90769 10.2448 5.90769 10.6141 6.27693L15.655 11.3178C16.0243 11.6871 16.0243 12.2857 15.655 12.655L10.6141 17.6959C10.4288 17.8824 10.1869 17.9743 9.94489 17.9743Z", fill: l.customColor ?? r }) }) });
}
export {
  C as AngleRightSmallOutlined
};
//# sourceMappingURL=angle-right-small-outlined.es.es.js.map
